<template>
  <div :class="$style.container">
    <RecommendedPoliciesCarouselCollapsableSection
      :itemType="itemType"
    />
    <PoliciesItemTable
      ref="itemTable"
      :gettingStartedItemType="gettingStartedPanelItemType"
      :isAsideOpen="isAsideOpen"
      :itemType="itemType"
      :recommendationSectionVisible="recommendationSectionVisible"
      :selectedModelId="selectedModelId"
      :setGettingStartedTooltipVisibility="showTooltip"
      :setSelectedModelId="setSelectedModelId"
      :useDropDownFilterComponent="FilterComponentConsts.PolicyDropDownFilter"
      :viewport="viewport"
    />
  </div>
</template>

<script>
import { FilterComponentConsts, LocalStorageConsts } from 'client/util/Constants';
import MainPanelMixin from 'components/MainPanel/mixins/MainPanelMixin';
import PoliciesItemTable from 'client/components/ItemTable/PoliciesItemTable.vue';
import RecommendedPoliciesCarouselCollapsableSection from 'client/policies/RecommendedPoliciesCarouselCollapsableSection.vue';

const { recommendedPoliciesDismissed } = LocalStorageConsts;

export default {
  name: 'PoliciesMainPanel',

  components: {
    PoliciesItemTable,
    RecommendedPoliciesCarouselCollapsableSection,
  },

  mixins: [MainPanelMixin],

  data() {
    return {
      recommendationSectionVisible: !localStorage.getItem(recommendedPoliciesDismissed),
      FilterComponentConsts,
    };
  },

  created() {
    // Legacy event names for refresh
    this.legacyAsidePanelCanceledEventName = 'policies-details:canceled';
    this.legacyAsidePanelSavedEventName = 'policies-details:saved';
  },

  mounted() {
    // Legacy: The main panel must refresh when the aside panel is saved or closed
    if (this.viewport) {
      const { refresh } = this.$refs.itemTable;
      this.viewport.on(this.legacyAsidePanelCanceledEventName, refresh);
      this.viewport.on(this.legacyAsidePanelSavedEventName, refresh);
    }
  },

  destroyed() {
    if (this.viewport) {
      this.viewport.off(this.legacyAsidePanelCanceledEventName);
      this.viewport.off(this.legacyAsidePanelSavedEventName);
    }
  },

};
</script>

<style module>
.container {
  height: 100%;
}
</style>
